// extracted by mini-css-extract-plugin
export default {"menu":"RelationshipsMenu_menu__Lgz8Y","button":"RelationshipsMenu_button__+xPYV"};